import React from 'react';

import { StyleSheet } from 'react-native';

import ActionButtonLink from 'components/action-button';
import { Box, Typography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';

const textDefaultColor = getDesignToken('text-default');
type ActionButtonLinkProps = React.ComponentProps<typeof ActionButtonLink>;

const getActionButtonLinkStyle = (style: ActionButtonLinkProps['style']) =>
  typeof style === 'function' ? style : [styles.actionButtonLink, style];

export const EmptyStateWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.emptyStateWrapper, style],
  });

export const StyledActionButtonLink = ({ style, ...props }: ActionButtonLinkProps) =>
  React.createElement(ActionButtonLink, {
    ...props,
    style: getActionButtonLinkStyle(style),
  });

export const HeaderText = ({ style, ...props }: TypographyProps) =>
  React.createElement(Typography, {
    ...props,
    color: textDefaultColor,
    fontSize: 'xl',
    lineHeight: 'md',
    style: [styles.headerText, style],
    variant: 'headerOne',
  });

export const SubText = ({ style, ...props }: TypographyProps) =>
  React.createElement(Typography, {
    ...props,
    color: textDefaultColor,
    fontSize: 'md',
    style: [styles.subText, style],
    textAlign: 'center',
    variant: 'copyOne',
  });

export const ImageWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.imageWrapper, style],
  });

const styles = StyleSheet.create({
  actionButtonLink: {
    marginTop: spacing.$4,
  },
  emptyStateWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: spacing.$0,
    marginTop: spacing.$10,
  },
  headerText: {
    margin: spacing.$0,
    marginTop: spacing.$4,
  },
  imageWrapper: {
    alignItems: 'center',
    height: 87,
    marginTop: spacing.$2,
    width: '100%',
  },
  subText: {
    marginBottom: spacing.$0,
    marginHorizontal: spacing.$8,
    marginTop: spacing.$4,
  },
});
